module.exports = __webpack_public_path__ + "static/bluunext-bold-59e21dc265455a52c577e799d29407c7.ttf";